"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.biEventTypeToLogMap = exports.acceptedEnvs = exports.BIInstrumentationVersion = exports.MaxCloudfrontRequestSize = exports.ErrorMessage = void 0;
var biEnums_1 = require("./bi-events/biEnums");
exports.ErrorMessage = {
    separator: ' - ',
    maximumRequestSizeExceeded: 'MAXIMUM_REQUEST_SIZE_EXCEEDED'
};
exports.MaxCloudfrontRequestSize = 8192;
/**
 * The version of the instrumentation BI log structure
 */
exports.BIInstrumentationVersion = "2.0.0.0";
exports.acceptedEnvs = [
    'local',
    'test-env',
    'e3',
    'sandbox',
    's3sj',
    'qat',
    'qas',
    'ppr',
    'prod'
];
exports.biEventTypeToLogMap = (_a = {},
    _a[biEnums_1.BIEventType.UserAction] = 'userAction',
    _a[biEnums_1.BIEventType.UiNavigation] = 'uiNavigation',
    _a[biEnums_1.BIEventType.ErrorReport] = 'errorReport',
    _a[biEnums_1.BIEventType.APIReport] = 'apiReport',
    _a[biEnums_1.BIEventType.SessionTags] = 'sessionTags',
    _a[biEnums_1.BIEventType.SessionStart] = 'sessionStart',
    _a[biEnums_1.BIEventType.SpecialEvent] = 'special',
    _a[biEnums_1.BIEventType.StageReport] = 'stageReport',
    _a);
